import Main from "./components/Pages/Main";

function App() {
  return (
    <div className="App" >
      <Main/>
    </div>
  );
}

export default App;
